import Cookies from 'universal-cookie'
import i18n from './i18n'

const dutch = "nl"
const french = "fr"
const english = "en"
const languages = [dutch, french]

const cookies = new Cookies(null, { path: '/' })

languages.forEach(l => {
    if (cookies.get('i18next')) {
        if (cookies.get('i18next').includes(l)) {
            i18n.changeLanguage(l)
        }
    }
})

export { dutch, french, english, languages}